import { forwardRef, type Ref, type SVGProps } from "react";
const IconQuoteFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fillRule="evenodd"
      d="M2 16C2 8.268 8.268 2 16 2a14 14 0 0 1 14 14c0 7.732-6.268 14-14 14S2 23.732 2 16m12.283 4.322q.99-1.01.99-2.456 0-1.408-.918-2.4-.918-.994-2.503-.994-.288 0-.558.09c-.115.039-.296-.092-.264-.21.385-1.38 1.7-2.157 3.066-2.345.654-.09.997-.611.997-1.23 0-.552-.449-1.005-1-.962a9.4 9.4 0 0 0-2.007.36q-1.314.397-2.214 1.228-.9.83-1.386 2.202Q8 14.978 8 16.928q0 1.986 1.062 3.195 1.062 1.21 2.79 1.21 1.44 0 2.43-1.01m8 0q.99-1.01.99-2.456 0-1.408-.918-2.4-.919-.994-2.503-.994-.288 0-.558.09c-.115.039-.297-.092-.266-.21.372-1.405 1.685-2.155 3.068-2.345.654-.09.997-.611.997-1.23 0-.552-.449-1.005-1-.962-1.78.137-3.202.65-4.239 1.588q-.918.83-1.386 2.202T16 16.928q0 1.986 1.062 3.195 1.062 1.21 2.79 1.21 1.44 0 2.43-1.01"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconQuoteFilledSVG);
ForwardRef.displayName = "IconQuoteFilled";
export { ForwardRef as IconQuoteFilled };
